import { useEffect, useRef } from 'react';

/**
 * Custom hook for auto-refreshing data without disrupting user work
 * @param {Function} fetchFunction - Function to call for refreshing data
 * @param {number} intervalSeconds - Refresh interval in seconds (default 5)
 * @param {boolean} isUserEditing - Flag to pause refresh when user is editing
 */
export function useAutoRefresh(fetchFunction, intervalSeconds = 5, isUserEditing = false) {
  const intervalRef = useRef(null);

  useEffect(() => {
    // Don't set up interval if user is currently editing
    if (isUserEditing) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Set up auto-refresh interval
    intervalRef.current = setInterval(() => {
      if (!isUserEditing && fetchFunction) {
        fetchFunction();
      }
    }, intervalSeconds * 1000);

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [fetchFunction, intervalSeconds, isUserEditing]);
}
